import React from 'react';
import PropTypes from 'prop-types';
import { map, findKey } from 'lodash';
import { Form } from 'react-bootstrap';
import * as nodeOps from '../../../api/Tasks/task-node-operations';
import { MAPSERVERELEMENTS_TYPES } from '../../../api/MapServerElements/MapServerElements';

const ConnParamMapServerElementFields = ({
  selectedNode,
  showMapServerElementTypes,
  updateFieldsToShow
}) => {
  if (!showMapServerElementTypes) return '';
  const allowedMapServerElementTypes = nodeOps.getAllowedMapServerElementTypes(selectedNode);
  return (
    <>
      <Form.Check
        type="checkbox"
        id="autorefresh"
        name="autorefresh"
        defaultChecked={nodeOps.shouldMapServerElementAutoRefresh(selectedNode)}
        label="Sincronize"
        onChange={event => updateFieldsToShow(event)}
      />
      <Form.Label>Layer Server Type</Form.Label>
      <Form.Control
        as="select"
        name="mapServerElementType"
        defaultValue={nodeOps.mapServerElementType(selectedNode)}
      >
        <option value="" />
        {map(allowedMapServerElementTypes, typeValue => {
          const enumKey = findKey(MAPSERVERELEMENTS_TYPES, type => type === typeValue);
          const { value, humanValue } = MAPSERVERELEMENTS_TYPES.properties[enumKey];
          return (
            <option value={value} key={value}>
              {humanValue}
            </option>
          );
        })}
      </Form.Control>
    </>
  );
};
ConnParamMapServerElementFields.propTypes = {
  selectedNode: PropTypes.object.isRequired,
  showMapServerElementTypes: PropTypes.bool.isRequired,
  updateFieldsToShow: PropTypes.func.isRequired
};

export default ConnParamMapServerElementFields;
